import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  id: null,
  email: null,
  first_name: null,
  last_name: null,
  access_token: null,
  fb_id: null,
  fb_access_token: null,
  facebook_token: null,
  isAuthenticated: false,

  image_url: null,
  profile_photo: null,                // Image URL
  display_name: null,
  living_situation: null,
  availability: 'Auckland',           // Default city
  bio: null,
  interests: [],
  needs: [],
  has_dog: false,
  dogs: [],
  police_checked: false,
  pet_insurance: false,
  completed_membership: false,
  verified: false,

  unread_notifications: [],
  all_notifications: [],
  match_requests: [],

  newsletter: true,   // TDSC email updates
  dogs_in_area: false,

  // #TODO content below
  billing_first_name: null,
  billing_last_name: null,
  billing_address_1: null,
  billing_address_2: null,
  billing_post_code: null,
  billing_city: null,
  billing_state: null,
  billing_country: null,
  billing_charity: null,

  current_membership: false,
  subscription: null,                 // Borrower or Owner
  membership_start_date: null,
  card_number: null,                  // Will be in format XXXX-XXX-XXXX-6789

  suburb: null,
};

/**
 * user in state
 * Provides account and authentication details
*/
export const user = handleActions( // eslint-disable-line
  {
    LOGIN: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    UPDATE_USER: (state, action) => Object.assign({}, state, action.payload),
    LOGOUT: () => INITIAL_STATE,
    READ_NOTIFICATION_BY_ID: (state, action) => Object.assign({}, state, {
      unread_notifications: state.unread_notifications.filter(notification =>
        notification.id !== action.payload,
      ),
    }),
  },
  INITIAL_STATE,
);



// WEBPACK FOOTER //
// ./src/reducers/user.js